import { configureStore, combineReducers } from "@reduxjs/toolkit";
import filter from "./reducers/filter";
import rate from "./reducers/rate";
import style from "./reducers/style";

const rootReducer = combineReducers({ filter, rate, style });

export const store = configureStore({ reducer: rootReducer });
